import OvertimeEvent from '@/components/requests/overtime/events/OvertimeEvent'

export default class CommentDeletedEvent extends OvertimeEvent {
  asText(viewer) {
    return `**${this.getActorName(viewer)}** deleted a comment`
  }
}
